/* eslint-disable no-undef */
// 设置缓存内容，刷新页面失效
class customCache {
  constructor({ path, name, value, expiration = new Date() + 600000 }) {
    this.path = path
    this.name = name
    this.value = value
    this.expiration = expiration * 1 || Infinity
  }
}
const getters = {
  getCacheByPath: (state) => (key) => {
    if (typeof key != 'string') return
    const [, path, name] = /^([^>]+)(?:>(.*))?$/.exec(key)
    const now = new Date()

    if (name) {
      // 取单个值
      state[path] || (state[path] = {})
      if (state[path][name] && state[path][name].expiration > now) {
        return state[path][name].value
      } else {
        delete state[path][name]
        return undefined
      }
    } else {
      // 取整个对象
      if (!state[path]) return
      const result = {}
      for (let name in state[path]) {
        if (state[path][name].expiration > now) result[name] = state[path][name].value
        else delete state[path][name]
      }
      return result
    }
  }
}
const mutations = {
  /**
   * @description key1设置单个变量，key2设置多个变量
   *
   * @param key1 {String} `${文件路径}>变量名称`
   * @param value1 {*} 设置的值，undefined不改变值
   *
   * @param key2 {String} `${文件路径}`
   * @param value2 {Object} 设置的多个值（对象）
   *
   * @return  {undefined}
   * @author 2021-5-17
   */
  setCache(state, { key, value, expiration }) {
    const [, path, name] = /^([^>]+)(?:>(.*))?$/.exec(key)
    state[path] || (state[path] = {})
    if (name) {
      // 设置变量
      if (state[path][name]) {
        // 有变量
        if (value !== undefined) state[path][name].value = value
        if (expiration !== undefined) state[path][name].expiration = expiration * 1 || Infinity
      } else {
        // 无变量
        state[path][name] = new customCache({ path, name, value, expiration })
      }
    } // 设置整个路径对象
    else {
      for (let name in value) {
        state[path][name] = new customCache({ path, name, value: value[name], expiration })
      }
    }
  },
  clearCache(state, key) {
    const [, path, name] = /^([^>]+)(?:>(.*))?$/.exec(key)
    if (path && state[path]) {
      if (name) delete state[path][name]
      else delete state[path]
    }
  },
  clearAllCache(state) {
    for (let key in state) {
      delete state[key]
    }
  }
}
export default {
  namespaced: true,
  state: {},
  getters,
  mutations
}
